import "src/components/atoms/logo/Logo.scss";

interface LogoProps {
  greyscale?: boolean;
}

const Logo = ({ greyscale = false }: LogoProps) => (
  <span className={`logo ${greyscale ? "logo--grey" : ""}`}>
    <span className="logo-text">
      R<span className="visually-hidden">ecipe finder home</span>
    </span>
  </span>
);
export default Logo;
